<!-- Fixed calendar widget ("inline" mode) -->
<ng-container
	*ngIf="showDatePickerOnly"
	[ngTemplateOutlet]="inlineTpl"
></ng-container>

<!-- Expandable date picker (calendar widget as "pop-up") -->
<div
	#popupWrapperTpl
	*ngIf="!showDatePickerOnly"
	class="d-inline-flex align-items-center cursor-pointer"
>
	<ng-container
		[ngTemplateOutletContext]="{ popupWrapper: popupWrapperTpl }"
		[ngTemplateOutlet]="popupTpl"
	></ng-container>
</div>


<!-- ######################### TEMPLATES ######################### -->
<!-- Fixed calendar widget ("inline" mode) -->
<ng-template #inlineTpl>
	<ngb-datepicker
		[maxDate]="maxDate"
		[minDate]="minDate"
		[(ngModel)]="controlValue"
		(dateSelect)="onDateSelect($event)"
	></ngb-datepicker>
</ng-template>

<!-- Expandable date picker (calendar widget as "pop-up") -->
<ng-template
	#popupTpl
	let-popupWrapperTpl="popupWrapper"
>
	<!-- Calendar icon -->
	<i
		class="icon-calendar date-picker-icon-color fs-xl"
		(click)="toggle()"
	></i>
	<!-- Input field showing the currently selected date -->
	<span
		class="date-picker-label"
		[class.box-shadow]="showShadow"
	>
		<input
			#datepickerPopup="ngbDatepicker"
			class="ps-3 py-0 border-0 bg-transparent cursor-pointer date-picker-input-color"
			type="text"
			[readOnly]="true"
			[(ngModel)]="controlValue"
			ngbDatepicker
			[maxDate]="maxDate"
			[minDate]="minDate"
			[positionTarget]="popupWrapperTpl"
			(click)="toggle()"
			(dateSelect)="onDateSelect($event)"
		>
	</span>
</ng-template>
